import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const PoliticaPrivacidade = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
          {/* Header Section */}
          <div className="bg-gradient-to-r from-emerald-600 to-teal-600 px-8 py-12">
            <div className="text-center">
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
                {t('politicaPrivacidade.title')}
              </h1>
              <p className="text-xl text-emerald-100">
                {t('politicaPrivacidade.organization')}
              </p>
            </div>
          </div>

          {/* Content Section */}
          <div className="px-8 py-12">
            <div className="prose prose-lg max-w-none">
              {/* Section 1 */}
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="w-8 h-8 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">
                    1
                  </span>
                  {t('politicaPrivacidade.sections.coleta.title')}
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  {t('politicaPrivacidade.sections.coleta.intro')}
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 ml-6">
                  {(t('politicaPrivacidade.sections.coleta.items') || []).map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
                <p className="text-gray-700 leading-relaxed mt-4">
                  {t('politicaPrivacidade.sections.coleta.cookies')}
                </p>
              </section>

              {/* Section 2 */}
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="w-8 h-8 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">
                    2
                  </span>
                  {t('politicaPrivacidade.sections.cookies.title')}
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  {t('politicaPrivacidade.sections.cookies.intro')}
                </p>

                <div className="bg-gray-50 rounded-lg p-6 mb-4">
                  <h4 className="font-semibold text-gray-900 mb-3">{t('politicaPrivacidade.sections.cookies.types.title')}</h4>
                  <div className="space-y-3">
                    <div className="flex items-start gap-3">
                      <span className="w-2 h-2 bg-emerald-500 rounded-full mt-2 flex-shrink-0"></span>
                      <div>
                        <p className="font-medium text-gray-900">{t('politicaPrivacidade.sections.cookies.types.necessary.title')}</p>
                        <p className="text-sm text-gray-600">{t('politicaPrivacidade.sections.cookies.types.necessary.description')}</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                      <div>
                        <p className="font-medium text-gray-900">{t('politicaPrivacidade.sections.cookies.types.analytics.title')}</p>
                        <p className="text-sm text-gray-600">{t('politicaPrivacidade.sections.cookies.types.analytics.description')}</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <span className="w-2 h-2 bg-purple-500 rounded-full mt-2 flex-shrink-0"></span>
                      <div>
                        <p className="font-medium text-gray-900">{t('politicaPrivacidade.sections.cookies.types.functional.title')}</p>
                        <p className="text-sm text-gray-600">{t('politicaPrivacidade.sections.cookies.types.functional.description')}</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <span className="w-2 h-2 bg-orange-500 rounded-full mt-2 flex-shrink-0"></span>
                      <div>
                        <p className="font-medium text-gray-900">{t('politicaPrivacidade.sections.cookies.types.marketing.title')}</p>
                        <p className="text-sm text-gray-600">{t('politicaPrivacidade.sections.cookies.types.marketing.description')}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                  <h4 className="font-semibold text-blue-900 mb-2">{t('politicaPrivacidade.sections.cookies.purposes.title')}</h4>
                  <ul className="list-disc list-inside text-blue-800 space-y-1 text-sm">
                    {(t('politicaPrivacidade.sections.cookies.purposes.items') || []).map((item, index) => (
                      <li key={index}><strong>{item.title}</strong> {item.description}</li>
                    ))}
                  </ul>
                </div>

                <p className="text-gray-700 leading-relaxed mt-4">
                  {t('politicaPrivacidade.sections.cookies.management')}
                </p>
              </section>

              {/* Section 3 */}
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="w-8 h-8 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">
                    3
                  </span>
                  {t('politicaPrivacidade.sections.uso.title')}
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  {t('politicaPrivacidade.sections.uso.intro')}
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 ml-6">
                  {(t('politicaPrivacidade.sections.uso.items') || []).map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </section>

              {/* Section 4 */}
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="w-8 h-8 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">
                    4
                  </span>
                  {t('politicaPrivacidade.sections.compartilhamento.title')}
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  {t('politicaPrivacidade.sections.compartilhamento.description')}
                </p>
              </section>

              {/* Section 5 */}
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="w-8 h-8 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">
                    5
                  </span>
                  {t('politicaPrivacidade.sections.armazenamento.title')}
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  {t('politicaPrivacidade.sections.armazenamento.description')}
                </p>
              </section>

              {/* Section 6 */}
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="w-8 h-8 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">
                    6
                  </span>
                  {t('politicaPrivacidade.sections.direitos.title')}
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  {t('politicaPrivacidade.sections.direitos.intro')}
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 ml-6">
                  {(t('politicaPrivacidade.sections.direitos.items') || []).map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </section>

              {/* Section 7 */}
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="w-8 h-8 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">
                    7
                  </span>
                  {t('politicaPrivacidade.sections.contato.title')}
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  {t('politicaPrivacidade.sections.contato.description')}
                  <a href={`mailto:${t('politicaPrivacidade.sections.contato.email')}`} className="text-emerald-600 hover:text-emerald-700 font-medium">
                    {t('politicaPrivacidade.sections.contato.email')}
                  </a>
                </p>
              </section>
            </div>

            {/* Contact Section */}
            <div className="mt-12 pt-8 border-t border-gray-200">
              <div className="bg-gray-50 rounded-xl p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-3">
                  {t('politicaPrivacidade.contact.title')}
                </h3>
                <p className="text-gray-600 mb-4">
                  {t('politicaPrivacidade.contact.description')}
                </p>
                <Link
                  to="/contato"
                  className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-emerald-600 to-teal-600 text-white font-semibold rounded-lg hover:from-emerald-700 hover:to-teal-700 transition-all duration-300"
                >
                  <span>{t('politicaPrivacidade.contact.button')}</span>
                  <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PoliticaPrivacidade;
